<template>
  <div class="techSupportBlock">
    <div class="left">
      <div class="l-start">
        <div class="subTitle">{{ info.subTitle }}</div>
      </div>
      <div class="title">{{ info.title }}</div>
      <div class="description">
        {{ info.description }}
      </div>
    </div>
    <div class="right" :style="info.iconStyle || {}">
      <img :src="info.icon">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.techSupportBlock {
  height: 300px;
  user-select: none;
  text-align: left;
  position: relative;
  backdrop-filter: blur(10px);
  .left {
    left: 30px;
    top: 50px;
    position: absolute;
    width: 600px;
    .subTitle {
      padding: 10px 20px;
      font-size: 14px;
      background-color: #fff;
      border-radius: 20px;
      color: #546792;
      box-shadow: 0px 2px 12px 0px rgba(0,0,0, 0.05);
    }
    .title {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 36px;
      font-weight: 600;
    }
    .description {
      font-size: 18px;
      color: #717a88;
      line-height: 28px;
    }
  }
  .right {
    right: 0px;
    top: 20px;
    position: absolute;
  }
}
</style>
